import { jsx as _jsx } from "react/jsx-runtime";
import classnames from "classnames";
import { Icon } from "../../components/Icon/Icon";
import styles from "./QuantityInput.module.scss";
export const QuantityInputButton = ({ value, changeValue, onChange, canZero = false, disabled, disabledMessage, component: Component, testId, className, handleOnMouseEnter, handleOnMouseLeave, }) => {
    const handleQuantityClick = () => {
        const newValue = value + changeValue;
        const isCorrectValue = (canZero && newValue >= 0) || newValue >= 1;
        if (isCorrectValue && onChange) {
            onChange(newValue);
        }
    };
    return (_jsx("button", { onMouseEnter: handleOnMouseEnter, onMouseLeave: handleOnMouseLeave, type: "button", disabled: disabled, title: disabled ? disabledMessage : "", onClick: handleQuantityClick, className: classnames([styles.button, className]), "data-testid": testId, children: _jsx(Icon, { component: Component, width: "16px", height: "16px" }) }));
};
//# sourceMappingURL=QuantityInputButton.js.map